'use strict';

var calcApplyOffsetMargin = function(container) {
	var info = document.querySelector('.text-image-overlay-layout--bottom .text-image-overlay-layout__info');
	var infoHeight = info.offsetHeight;
	var imageHeight = document.querySelector('.text-image-overlay-layout--bottom .text-image-overlay-layout__img-cell').offsetHeight;

	var offset = infoHeight / 2;
	if (imageHeight < infoHeight) {
		offset = imageHeight / 2;
	}

	container.style.marginBottom = "-" + offset + "px";
	info.style.transform = `translate(0px, -${offset}px)`;
}

var init = function() {
	var container = document.querySelector('.text-image-overlay-layout--bottom .text-image-overlay-layout__info');
	if (document.body.contains(container)) {

		calcApplyOffsetMargin(container);

	}
}

module.exports = {
	init: init
};